export default __webpack_public_path__ + "static/media/Icon-inbox.e07d4ef5.svg";